const locale = {
	pageTitle: '走心機精密加工產品 | 擎億精密有限公司',
	pageDesc: '擎億精密 Cincom L20 瑞士型走心機加工產品展示，φ1–20mm 小徑精密零件，涵蓋軸類、螺絲、套管、連接器，材質包含不鏽鋼、鋁合金、銅、鈦合金，可依圖面客製。',
	pageKeywords: '走心機加工產品, Cincom L20, 瑞士型車床, 小徑精密零件, 軸類零件, 螺絲加工, 套管加工, 連接器加工, 醫療零件, 航太零件, 台灣精密加工',
	title: '精密加工產品',
	subtitle: 'CNC 車銑複合精密零件展示',
	catAll: '全部',
	catShaft: '軸類／銷類',
	catScrew: '螺絲／緊固件',
	catBushing: '套管／套筒',
	catConnector: '接頭／連接件',
	catPlate: '板類',
	catComplex: '複合加工件',
	catWorm: '蝸桿',
	matSus: '不鏽鋼',
	matBrass: '黃銅',
	matCopper: '紅銅',
	matAlu: '鋁合金',
	matTi: '鈦合金',
	matPlastic: '工程塑膠',
	dialogTitle: '擎億精密有限公司',
};

export default locale;
